module.exports = __webpack_public_path__ + "img/service-parts-grid-tiles.edbae9b0.png";